import Icons from 'components/atoms/Icons';
import React, { useState } from 'react';

type ActionBarProps = {
	print?: boolean;
	copy?: boolean;
	suggestEdit?: boolean;
};

const ActionBar = (props: ActionBarProps): JSX.Element => {
	const { print, copy, suggestEdit } = props;
	const [copied, setCopied] = useState(false);

	const copyToClipboard = () => {
		navigator.clipboard.writeText(window.location.href).then(
			() => {
				setCopied(true);
				setTimeout(() => {
					setCopied(false);
				}, 2000);
			},
			() => {
				console.log('failed to copy current url to clipboard');
			}
		);
	};

	return (
		<div className="action-bar" data-module="ProfileActions">
			{print && (
				<button className="print-btn" onClick={() => window.print()}>
					<Icons id="icon-print" /> Print
				</button>
			)}
			{copy && (
				<button className="copy-link-btn" onClick={copyToClipboard}>
					<Icons id="copy" /> Copy Link
					<span className={`clipboard-notification ${copied ? 'active' : ''}`}>
						Link copied to clipboard
					</span>
				</button>
			)}
			{suggestEdit && (
				<button className="profile-update">
					<a
						className="profile-update-link"
						href="https://www.osfhealthcare.org/provider-update"
						target="_blank"
					>
						Suggest an edit
					</a>
				</button>
			)}
		</div>
	);
};

export default ActionBar;
